import { render } from "./InterestChargeFeesChart.vue?vue&type=template&id=86749a56&ts=true"
import script from "./InterestChargeFeesChart.vue?vue&type=script&lang=ts"
export * from "./InterestChargeFeesChart.vue?vue&type=script&lang=ts"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__